import script from "./App.vue?vue&type=script&setup=true&lang=js"
export * from "./App.vue?vue&type=script&setup=true&lang=js"

import "./App.vue?vue&type=style&index=0&id=7540f6d1&lang=scss"
import "./App.vue?vue&type=style&index=1&id=7540f6d1&lang=scss&scoped=true"
script.__scopeId = "data-v-7540f6d1"

export default script